export default "__VITE_ASSET__C4c1SCmS__"